import { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useStorage } from '../../stores/storage/StorageAction';
import './StorageWidget.css';

const formatStorageUnit = (bytes) => {
  if (bytes === undefined || bytes === null) return '0MB';
  const megabytes = bytes / 1_000_000;
  if (megabytes >= 1000) {
    const gigabytes = Math.floor((megabytes / 1000) * 100) / 100;
    return `${gigabytes}GB`;
  }
  const formattedMB = Math.floor(megabytes * 100) / 100;
  return `${formattedMB}MB`;
};

const StorageWidget = ({ title = 'MYBOX' }) => {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const storage = useSelector((state) => state.storage.data);
  const storageAPI = useStorage();

  useEffect(() => {
    if ( session && session.companySeq 
      && (!storage || storage.companySeq !== session.companySeq)) {
        dispatch(storageAPI.request.get({ companySeq: session.companySeq }));
    }
  }, [dispatch, storageAPI, session?.companySeq]);

  const formattedUsed = formatStorageUnit(storage.usingStorage);
  const formattedTotal = formatStorageUnit(storage.maxStorage);
  const usagePercentage = storage.maxStorage > 0
    ? (storage.usingStorage / storage.maxStorage) * 100
    : 0;
  const remainingPercentage = 100 - usagePercentage;

  return (
    <div className="storage-widget">
      <div className="widget-header">
        <span className="widget-title">{title}</span>
        <span className="widget-remaining">{Math.round(remainingPercentage)}% 남음</span>
      </div>
      <div className="widget-usage">
        <span className="usage-used">{formattedUsed}</span>
        <span className="usage-total"> / {formattedTotal}</span>
      </div>
      <div className="progress-bar-container">
        <div
          className="progress-bar-fill"
          style={{ width: `${usagePercentage}%` }}
        />
      </div>
    </div>
  );
};

export function useSearchStorage() {
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session.data);
  const storageAPI = useStorage();
  return useCallback(() => {
    if (session && session.companySeq) {
      dispatch(storageAPI.request.get({ companySeq: session.companySeq }));
    }
  }, [dispatch, storageAPI, session]);
}

export default StorageWidget;
